import { Person } from '@mui/icons-material';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AuthService from 'src/services/authService';
import UserService from 'src/services/userService';
import moment from 'moment';


const CompletedRegistration = () => {
  const { user } = AuthService.getAuth();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    setLoading(true);
    UserService.updateProfile(
      { confirmedDetailsAt: moment().toDate() }, 
      user.id
    )
    .finally(() => setLoading(false));
  }, []);


  const profileLink = (
    <Button 
      variant="text" 
      color="secondary" 
      size="small"
      style={{ display: "inline-block", verticalAlign: "middle" }}
      onClick={() => history.push('/profile')}
    >
      <Person className="tab-icon" /> Profile
    </Button>
  );

  if (loading) return null;

  return (
    <div className="onboarding-form">
      <div className="header-info complete-view">
        <div className="description">
          <Typography variant="h4" fontWeight="medium">You're All Set</Typography>
          <Typography variant="body1">
            Your responses have been sent to our team. You can always view or update your information in your {profileLink}. If any additional
            information is required, we will contact you. Otherwise you are all
            set!
          </Typography>
        </div>
        <Button
          variant="contained"
          size="large"
          href="/patientDashboardPage"
          type="submit"
        >
          Enter Dashboard
        </Button>
      </div>
    </div>
  );
};

export default CompletedRegistration;